import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import CallToAction from '../components/CallToAction';
import { Link } from 'react-router-dom';
import './About.css';

// Import images
import academyLogo from '../assets/images/ProgenX Akademi.png';
import hakkindaHeroImage from '../assets/images/hakkinda.jpg';

const ArabicAbout = () => {
  return (
    <div className="about">
      <Helmet>
        <title>عن ProgenX | تقنيات التعليم والمعلومات</title>
        <meta name="description" content="ProgenX هي شركة تقنية تأسست بتمويل TÜBİTAK BİGG، وتسارع التحول الرقمي في التعليم وتحول تجارب التعلم بالتقنيات المبتكرة. تعرف على رؤيتنا ورسالتنا وخدماتنا." />
        <meta name="keywords" content="عن progenx, رؤية progenx, رسالة progenx, التحول الرقمي في التعليم, التعليم بالذكاء الاصطناعي, tübitak bigg" />
        <link rel="canonical" href="https://progenxacademy.com/ar" />
      </Helmet>
      
      <Hero 
        title="من نحن" 
        backgroundImage={hakkindaHeroImage}
      />
      
      <section className="about-content">
        <div className="container">
          <div className="about-row">
            <div className="about-text">
              <h2 className="section-title">أكاديمية ProgenX</h2>
              <div className="about-description">
                <p>
                  ProgenX هي شركة تقنية تقدم حلولاً مبتكرة في تقنيات التعليم وتطور منصات التعلم المدعومة بالذكاء الاصطناعي. 
                  شركتنا، التي شاركت في قمة التقنيات التعليمية التركية (TETZ)، تعمل تحت إشراف ETKİM MEB، وهي عضو في AWS Activate، 
                  وحصلت على شارة Teknogirişim التي تمنحها وزارة الصناعة والتكنولوجيا لجمهورية تركيا، 
                  تهدف إلى دعم التحول الرقمي في التعليم وأن تكون إلى جانب الطلاب في رحلة نجاحهم.
                </p>

                <p>
                  كأكاديمية Progenx، نتبنى نهجاً يعجل التحول الرقمي في التعليم ويحول تجارب التعلم بالتقنيات المبتكرة. مع الحلول الذكية التي نطورها في مجال التعليم، نقبل كل طفل كفرد فريد ونقدم له تجارب تعلم مخصصة بالكامل.
                </p>
                <p>
                Progenx، وهي شركة تأسست بتمويل TÜBİTAK BİGG، لا تقتصر على تقنيات التعليم؛ بل تقدم أيضاً مجموعة واسعة من الخدمات في مجال تقنية المعلومات والتحول الرقمي. مع حلول علوم البيانات والذكاء الاصطناعي لدينا، نستخرج معلومات ذات معنى من مجموعات البيانات الكبيرة ونضيف قوة لعمليات اتخاذ القرار في الشركات. مع خدمات تطوير التطبيقات المحمولة والويب لدينا، نخلق منتجات رقمية سهلة الاستخدام وعالية الأداء ونرقمن العمليات التجارية.
                </p>
                <p>
                  Progenx هي منصة مبتكرة مدعومة بالذكاء الاصطناعي تهدف إلى ضمان تكافؤ الفرص في التعليم وزيادة النجاح الأكاديمي من خلال تقديم حلول مناسبة لاحتياجات التعلم الفردية لكل طالب. هدفنا هو التدخل حيث تفشل الطرق التعليمية التقليدية وتعظيم الإمكانات الفردية للطلاب.
                </p>
                
                <h3>رؤيتنا</h3>
                <p>
                  نهدف إلى أن نكون قادة ينتجون حلولاً مبتكرة على مستوى العالم في مجال التعليم والتكنولوجيا، ويعظمون إمكانات الأفراد والشركات. نهدف إلى تنفيذ عمليات التحول الرقمي المستدامة في المجتمع من خلال تطوير التكنولوجيا بطريقة يمكن للجميع الوصول إليها.
                </p>
                
                <h3>رسالتنا</h3>
                <p>
                  كأكاديمية Progenx، نضمن أن كل طالب يكتشف إمكاناته الفريدة من خلال تقديم حلول رقمية مخصصة في التعليم. بينما نزيد كفاءة الشركات بتقنية المعلومات والبرمجيات وحلول التحول الرقمي، نضع أعلى المعايير في القطاع مع المشاريع المبتكرة القائمة على التكنولوجيا.
                </p>
              </div>
            </div>
            
            <div className="about-image">
              <img src={academyLogo} alt="شعار أكاديمية ProgenX" />
              <div className="about-quote">
                <p>"أفضل طريقة للتنبؤ بالمستقبل هي إنشاؤه."</p>
                <p className="quote-author">-بيتر دراكر وأبراهام لنكولن</p>
              </div>
              <div className="about-cta">
                <Link to="/progenxakademi" className="btn btn-primary">
                  اكتشف الآن
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <CallToAction 
        title="خطو نحو المستقبل بالتكنولوجيا، تعرف على قوة الابتكار!"
        subtitle="تواصل معنا الآن ودعنا نحقق أحلامك."
        buttonText="تواصل معنا" 
        buttonLink="/iletisim" 
      />
    </div>
  );
};

export default ArabicAbout; 